import hitThumbnailImg from '@/assets/images/hit2/logo_hit2@2x.png';
import hitIntroImg from '@/assets/images/hit2/img_hit2@2x.png';
import prasiaThumbnailImg from '@/assets/images/prasia/logo_prasia@2x.png';
import prasiaIntroImg from '@/assets/images/prasia/img_prasia@2x.png';

const data = {};

// 포인트 리스트 (fnb)
data.pointThumbnailList = {
  data: {
    code: 0,
    message: 'success',
    data: {
      rpServiceInfoList: [
        {
          language: 0,
          rpId: 1,
          serviceName: '히트2',
          pathKey: 'hit2',
          thumbnailImageUrl: hitThumbnailImg,
        },
        {
          language: 0,
          rpId: 2,
          serviceName: '프라시아 전기',
          pathKey: 'wp',
          thumbnailImageUrl: prasiaThumbnailImg,
        },
      ],
    },
  },
};

// 포인트 리스트 (gnb & intro)
data.pointList = {
  data: {
    code: 0,
    message: 'success',
    data: {
      rpServiceInfoList: [
        {
          language: 0,
          rpId: 1,
          pathKey: 'hit2',
          pointName: '히트 포인트',
          description: '넥슨 크리에이터즈 후원1',
          listImageUrl: hitIntroImg,
        },
        {
          language: 0,
          rpId: 2,
          pathKey: 'wp',
          pointName: '프라시아 전기 포인트',
          description: '넥슨 크리에이터즈 후원2',
          listImageUrl: prasiaIntroImg,
        },
      ],
    },
  },
};

export default {
  ...data,
};
